import { getNoOfDaysInYear } from '@whitbread-eos/utils';
export var CONSENT_COOKIE = 'consent_cookie';
export var ONE_YEAR_IN_MINUTES = 60 * 24 * getNoOfDaysInYear(new Date().getFullYear());